export class AppConfig {
    rootUrl!: string;
}
